import { createSourcingRequestEmbeddedConfig } from './sourcing-request-embedded.factory';

/**
 * Sourcing Request embedded list — scoped to a single item (via line item
 * matches). Mounted on the Item Detail "Sourcing Requests" tab. The
 * line-level item filter is applied at the tab/queryFn layer
 * (`sourcingRequestLineItem`).
 */
export const SOURCING_REQUEST_ITEM_EMBEDDED_CONFIG =
	createSourcingRequestEmbeddedConfig({
		id: 'default-sourcing-requests-item-embedded',
		name: 'Item Sourcing Requests',
	});
